module.exports = __webpack_public_path__ + "static/media/luckyBagImg.0421ab4c.png";